import React, { useState, FormEvent } from 'react'

import { getAuthUser } from '../../../helpers'
import { CreateSupplierBrandParams } from '../../../api/requests'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from 'components/common'

interface CreateSupplierBrandFormProps {
    handleSubmit: (
        e: FormEvent<HTMLFormElement>,
        inputs: CreateSupplierBrandParams
    ) => void
    isSubmitting?: boolean
}

export const SupplierBrandCreateForm = (props: CreateSupplierBrandFormProps) => {
    const { handleSubmit, isSubmitting } = props
    const ability = defineAbilityFor(getAuthUser())

    const defaultInputs = {
        name: ''
    }
    const [inputs, setInputs] = useState(defaultInputs)

    const updateInputs = (field: string, value: number | string) => {
        setInputs({
            ...inputs,
            [field]: value
        })
    }

    if (!ability.can('Create', 'SupplierBrand')) {
        return <InsufficientPermissions />
    }

    return (
        <form onSubmit={(e) => handleSubmit(e, inputs)}>
            <div className='row mb-4'>
                <div className='col-12'>
                    <label htmlFor='nameInput'>Brand Name</label>
                    <input
                        className='form-control'
                        id='nameInput'
                        onChange={(e) => updateInputs(
                            'name',
                            e.target.value
                        )}
                        required
                        type='text'
                        maxLength={35}
                        value={inputs.name} />
                </div>
            </div>
            <div className='row mb-5'>
                <div className='col-12 d-flex justify-content-center'>
                    <button className='btn btn-primary' type='submit' disabled={!!isSubmitting}>
                        Submit
                    </button>
                </div>
            </div>
        </form>
    )
}
